<template src="./HelpDeskForm.html"></template>

<script>
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";

export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      departament: null,
      name: null,
      email: null,
      origin: null,
      description: null,
      details: "",
      userName: "",
      cpf: "",
      invalidFields: {
        departament: false,
        name: false,
        email: false,
        origin: false,
        description: false,
        cpf: false,
      },
      callback: null,
      origins: [
        { name: "----- PORTAL -----", $isDisabled: true },
        { name: "Portal Cliente" },
        { name: "Portal Profissional" },
        { name: "Portal Clínicas" },
        { name: "Portal Empresas" },
        { name: "-----  MÓDULO -----", $isDisabled: true},
        { name: "Módulo Atendimento" },
        { name: "Módulo Comercial" },
        { name: "Módulo Financeiro" },
        { name: "Módulo Profissional" },
        { name: "Módulo Clínicas" },
        { name: "----- OUTROS -----", $isDisabled: true },
        { name: "Cadastros pelo Site" },
        { name: "Configurações/Cargas" },
        { name: "Melhorias" },
        { name: "Dúvidas" },
      ],
      filesList: [],
    };
  },
  mounted() {
    const vm = this;
    vm.callback = vm.$route.query.callback;
  },
  methods: {
    verifyDepartament() {
      this.invalidFields.departament = this.testNullUndefinedEmpty(this.departament)
      || this.departament.length < 2
      || this.departament == '..'
      || this.departament.trimStart() == ""
      || this.departament.trimStart() == "."
      || this.departament.trimEnd() == "."

    },

    verifyName() {
      this.invalidFields.name = !this.testFullName(this.name) ;
    },

    verifyEmail() {
      this.invalidFields.email = !this.validateEmail(this.email);
    },

    verifyOrigin() {
      this.invalidFields.origin = this.testNullUndefinedEmpty(this.origin);
    },

    verifyDescription() {
      this.invalidFields.description = !this.testFullName(this.description);
    },

    verifyCPF() {
      this.invalidFields.cpf = this.testNullUndefinedEmpty(this.cpf)
        ? false
        : !this.validateCPF(this.cpf);
    },

    goHome() {
      window.location.href = this.callback;
    },

    submit() {
      const vm = this;
      const error = vm.invalidFields;
      var invalid = false;
      vm.verifyDepartament();
      vm.verifyName();
      vm.verifyEmail();
      vm.verifyOrigin();
      vm.verifyDescription();
      vm.verifyCPF();

      invalid =
        error.departament ||
        error.name ||
        error.email ||
        error.origin ||
        error.description ||
        error.cpf;
      if (!invalid) {
        vm.createTask();
      }
    },

    swallError() {
      return this.$swal({
        title: "Atenção!",
        text: "Ocorreu um erro, tente novamente ou contate um administrador.",
        icon: "error",
      });
    },

    swallSuccess() {
      return this.$swal({
        title: "Solicitação criada!",
        text: "Aguarde o contato do nosso time de suporte!",
        icon: "success",
      });
    },

    swallErrorAttachments() {
      this.$vs.notify({
        title: "Atenção!",
        text:
          "O chamado foi registrado, porém um dos arquivos não pode ser anexado",
        color: "warning",
        icon: "error",
        position: "top-right",
      });
    },

    addFile(e) {
      var vm = this;
      let droppedFiles = e.dataTransfer.files;
      let doUpload = false;

      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        if (f.size > 10000000) {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              'O arquivo "' +
              f.name +
              '" ultrapassou o tamanho permitido de 10MB!',
            color: "warning",
            icon: "error",
            position: "top-right",
          });

          return (doUpload = false);
        }

        doUpload = true;
      });

      if (droppedFiles.length > 0 && doUpload === true) {
        for (var i = 0; i < droppedFiles.length; i++) {
          let file = droppedFiles[i];

          const formData = new FormData();

          formData.append("file", file);
          vm.filesList.push(formData);
        }
      }
    },

    clickAddFile: function (e) {
      var vm = this;
      var input = e.target;

      if (input.files[0].size > 10000000) {
        vm.$vs.notify({
          title: "Atenção!",
          text:
            'O arquivo "' +
            input.files[0].name +
            '" ultrapassou o tamanho permitido de 10MB!',
          color: "warning",
          icon: "error",
          position: "top-right",
        });
      }
      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = (e) => {
          vm.documentData = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);

        const formData = new FormData();
        formData.append("file", input.files[0], input.files[0].name);

        vm.filesList.push(formData);
      }
    },

    getDescription() {
      return (
        ` **Setor do Relator** : \\n ${this.departament} \\n \\n **Relator**: \\n ${this.name} \\n\\n **E-mail**: \\n ${this.email} \\n \\n **Este chamado refere-se ao**: ` +
        `\\n ${this.origin.name} \\n\\n **Breve descritivo do chamado**: \\n ${this.description} \\n \\n **Detalhes**: \\n ${this.details.replaceAll('"','\\"').replaceAll('\t','\\t').replaceAll("\n", "\\n")} ` +
        `\\n \\n **Nome do cliente, profissional ou clínica (usuário envolvido)**: \\n ${this.userName} \\n \\n **CPF do cliente**: \\n ${this.cpf}`
      );
    },

    createTask() {
      const vm = this;

      const today = vm.formatDateHourFromDate(new Date());
      const nameTask = vm.departament + "-" + today + "-" + vm.description;
      const description = vm.getDescription();
      const task = {
        name: nameTask,
        markdown_description: description,
        status: "Triagem",
        priority: 3,
        due_date_time: false,
        start_date_time: false,
        notify_all: false,
        check_required_custom_fields: false,
      };

      console.log(description);
      vm.axios
        .post(vm.$store.state.filooServer + "helpdesk/create-task", task)
        .then(function (response) {
          if (response.status === 201) {
            if (vm.testNullUndefinedEmpty(vm.filesList)) {
              vm.swallSuccess();
              vm.clearFields();
            } else {
              vm.addAttachment(response.data);
              vm.swallSuccess();
              vm.clearFields();
            }
          }
        })
        .catch(function () {
          vm.swallError();
        });
    },

    clearFields() {
      this.departament = null;
      this.name = null;
      this.email = null;
      this.origin = null;
      this.description = null;
      this.details = null;
      this.userName = null;
      this.cpf = null;
      this.filesList = [];
    },

    addAttachment(taskId) {
      const vm = this;
      vm.filesList.forEach((file) => {
        vm.axios
          .post(
            vm.$store.state.filooServer + `helpdesk/task/${taskId}/attachment`,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .catch(function (error) {
            if (error.status != 202) {
              vm.swallErrorAttachments();
            }
          });
      });
    },

    removeFile(file) {
      var vm = this;
      vm.filesList.pop(file);
    },
  },
};
</script>
<style lang="scss" src="./HelpDeskForm.scss"/>
